import './index.css'

import React, { Component } from 'react'
import Resume from '../form/resume'
import ResumeOptions from '../form/resume-options'
import ThemePicker from '../form/theme-picker/ThemePicker'
import Spinner from '../../components/utils/spinner'
import MyContentLoader from '../../components/utils/content-loader'
import { Link } from 'react-router-dom'

import axios from 'axios'
import { nanoid } from 'nanoid'
import Scrollbar from 'react-smooth-scrollbar'
import { sortByOrderOrDate } from '../../services/sort-sections'

class EditComponent extends Component {
  constructor(props) {
    super(props)

    let resumeData = JSON.parse(localStorage.getItem('resumeData'))

    if (resumeData !== null) {
      if (resumeData.hash.length > 0 && resumeData.psw.length) {
        this.state = {
          resume: {},
          hash: resumeData.hash,
          psw: resumeData.psw,
          token: resumeData.token,
          dataCompleted: false,
          saving: false,
          preview: null,
          error: false,
          theme: null,
          style: null,
        }
      }
    }
  }

  update = (field, data, triggerSave = false) => {
    let resume = this.state.resume

    if (field === 'showExperience') {
      resume.skill.showExperience = data
    } else if (field === 'skill') {
      resume.skill.list = data
    } else {
      resume[field] = data
    }

    this.setState({ resume }, triggerSave ? this.saveResume : undefined)
  }

  updateHeaders = (field, data) => {
    let resume = this.state.resume
    resume.headers[field] = data
    this.setState({ resume })
  }

  componentDidMount = () => {
    if (this.state) {
      this.fetchData()
    } else {
      this.props.history.push('/')
    }
  }

  fetchData = () => {
    clearInterval(this.refreshTimeID)

    let options = { headers: {} }

    if (this.state.psw !== null) {
      options.headers.psw = this.state.psw
    } else {
      options.headers.authorization = this.state.token
    }

    axios
      .get(`${process.env.REACT_APP_API_URL}/resume/${this.state.hash}/edit`, options)
      .then(response => {
        let resume = response.data.resume
        const theme = response.data.theme || null
        const style = response.data.style || null

        this.setState({
          error: false,
          dataCompleted: true,
          resume: this.generateKeys(resume),
          theme,
          style,
        })
      })
      .catch(err => {
        this.setState({ error: true, dataCompleted: false })
        this.props.history.push('/')
      })
  }

  saveResume = () => {
    clearInterval(this.refreshTimeID)

    let options = { headers: {} }

    if (this.state.psw !== null) {
      options.headers.psw = this.state.psw
    } else {
      options.headers.authorization = this.state.token
    }

    this.setState({ saving: true, error: false })

    axios
      .patch(
        `${process.env.REACT_APP_API_URL}/resume/${this.state.hash}/edit`,
        { content: this.state.resume },
        options,
      )
      .then(() => {
        return axios.get(
          `${process.env.REACT_APP_API_URL}/resume/${this.state.hash}/preview-html`,
          { ...options, responseType: 'blob' },
        )
      })
      .then(response => {
        if (this.state.preview) {
          URL.revokeObjectURL(this.state.preview)
        }
        const htmlUrl = URL.createObjectURL(response.data)
        this.setState({ saving: false, preview: htmlUrl, error: false })
      })
      .catch(() => {
        this.setState({ saving: false, error: true })
      })
  }

  generateKeys = resume => {
    const defaultHeaders = {
      summary: '',
      education: '',
      work: '',
      link: '',
      language: '',
      skill: '',
      course: '',
      project: '',
    }

    let newResume = {
      name: resume.name,
      lang: resume.lang,
      basics: resume.basics,
      skill: { showExperience: resume.skill.showExperience, list: [] },
    }

    newResume.headers = { ...defaultHeaders, ...resume.headers }

    newResume.education = resume.education.map(element => {
      element.key = nanoid()
      return element
    })

    newResume.work = sortByOrderOrDate(resume.work.map(element => {
      element.key = nanoid()
      return element
    }))

    newResume.link = resume.link.map(element => {
      element.key = nanoid()
      return element
    })

    newResume.language = resume.language.map(element => {
      element.key = nanoid()
      return element
    })

    newResume.skill.list = resume.skill.list.map(element => {
      element.key = nanoid()
      return element
    })

    newResume.course = sortByOrderOrDate(resume.course.map(element => {
      element.key = nanoid()
      return element
    }))

    newResume.project = sortByOrderOrDate(resume.project.map(element => {
      element.key = nanoid()
      return element
    }))

    return newResume
  }

  onPreviewLoad = e => {
    try {
      const height = e.target.contentWindow.document.body.scrollHeight
      e.target.style.height = height + 'px'
    } catch (_) {}
  }

  showResumePreview = () => {
    if (this.state.preview) {
      return (
        <iframe
          src={this.state.preview}
          title="Resume preview"
          className="resume-preview-frame"
          onLoad={this.onPreviewLoad}
        />
      )
    }

    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
        <MyContentLoader
          style={{ backgroundColor: 'white', borderRadius: '4px', width: '100%', maxWidth: '940px' }}
        />
      </div>
    )
  }

  onThemePreviewRefresh = htmlUrl => {
    if (this.state.preview) {
      URL.revokeObjectURL(this.state.preview)
    }
    this.setState({ preview: htmlUrl })
  }

  showForm = () => {
    return (
      <React.Fragment>
        <Scrollbar
          style={{
            flex: 1,
            height: '100%',
            padding: '20px 40px',
          }}
        >
          <Resume
            name={this.state.resume.name}
            lang={this.state.resume.lang}
            basics={this.state.resume.basics}
            education={this.state.resume.education}
            work={this.state.resume.work}
            link={this.state.resume.link}
            language={this.state.resume.language}
            skill={this.state.resume.skill.list}
            showExperience={this.state.resume.skill.showExperience}
            course={this.state.resume.course}
            project={this.state.resume.project}
            headers={this.state.resume.headers}
            update={this.update}
            updateHeaders={this.updateHeaders}
          />

          <div style={{ height: '30px' }}></div>
        </Scrollbar>

        <Scrollbar style={{ flex: 1, height: '100%', backgroundColor: '#f6f5f7' }}>
          {this.showResumePreview()}
        </Scrollbar>
      </React.Fragment>
    )
  }

  render() {
    if (this.state && this.state.dataCompleted) {
      return (
        <div className="edit-page">
          <nav className="edit-navbar">
            <a href="/" className="edit-navbar-logo">
              <img src="/logo.png" alt="makeresume.co" />
            </a>
            <ThemePicker
              compact
              hash={this.state.hash}
              theme={this.state.theme}
              style={this.state.style}
              onPreviewRefresh={this.onThemePreviewRefresh}
            />
            <div className="edit-navbar-actions">
              <Link to="/share" className="edit-navbar-share-link">My link</Link>
              <ResumeOptions
                saving={this.state.saving}
                error={this.state.error}
                hash={this.state.hash}
                saveResume={this.saveResume}
              />
            </div>
          </nav>
          <div className="edit-panels">
            {this.showForm()}
          </div>
        </div>
      )
    } else {
      return <Spinner />
    }
  }
}

export default EditComponent
